import { logger } from 'affiny-core/logger';
import { ELoggerLevel } from 'affiny-core/logger.types';
import { IGraph } from 'affiny-core/modules/api/models/compatibilityReport/compatibilityReport.types';
import { IMemberChoices } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { IHobbies } from 'affiny-core/redux/selectors/choicesItemsSelectors/hobbiesSelectors';
import uniqBy from 'lodash/uniqBy';

export interface IChip {
  label: string;
  isInCommon?: boolean;
  isSelected?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const logInvalidQuestion = (
  payload: IMemberChoices,
  answer: number[]
) => {
  const questionId = Object.keys(payload)[0];
  const message = `The question ${questionId} has incompatible Id ${answer}`;

  logger.log(message, { level: ELoggerLevel.Warning });
};

export const getUniqueHobbies = (hobbies?: IHobbies) =>
  hobbies && hobbies.values && hobbies.sports
    ? uniqBy([...hobbies.values, ...hobbies.sports], hobby => hobby.label)
    : [];

export const formatGraph = (
  initialGraph: IGraph[],
  i18nTranslator: (key: string) => string
) => {
  const formatedGraph: IChip[] = [];

  initialGraph.forEach(graph => {
    formatedGraph.push({
      label: i18nTranslator(`personalityReport.values.valueLabels.${graph.id}`),
      isInCommon: false,
    });
  });

  return formatedGraph;
};

export const translateInformations = (
  i18nTranslator: (key: string) => string,
  familyStatus: string[],
  bodyShapeHeightWeight: string[]
) => {
  if (familyStatus[0] === 'profileCapture.skipQuestion') {
    familyStatus = [i18nTranslator('profileCapture.skipQuestion')];
  } else if (familyStatus[familyStatus.length - 1].length === 1) {
    const lastEl = familyStatus.length - 1;
    const childNumber = familyStatus[lastEl];

    familyStatus[lastEl] = i18nTranslator(
      'profile.informations.response.childNumber.' + childNumber
    );
  }

  // case 1 : shape, height, weight
  // case 2 : shape, height
  // case 3 : height
  // case 4 : height, weight
  // Try to find height on the first or second position with the string length
  // Because the height unit is missing in the reflist.
  // Example :
  // length = 3 for example: 178
  // length = 4 for example: -140
  if (
    bodyShapeHeightWeight[0]?.length === 3 ||
    bodyShapeHeightWeight[0]?.length === 4 ||
    bodyShapeHeightWeight[1]?.length === 3 ||
    bodyShapeHeightWeight[1]?.length === 4
  ) {
    bodyShapeHeightWeight[
      bodyShapeHeightWeight[0].length === 3 ||
      bodyShapeHeightWeight[0].length === 4
        ? 0
        : 1
    ] += ' ' + i18nTranslator('profileCapture.units.height');
  }

  return { familyStatus, bodyShapeHeightWeight };
};
